module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point4_3-d35241a918364e9a4cc47925e51e88d5.jpg";